@if ({
  areas: residentAreas$ | async,
  commonAreas: commonAreas$ | async,
  commercialAreas: commercialAreas$ | async,
  floors: floors$ | async
}; as vm) {
  <div class="search">
    <ion-searchbar #filter
      mode="ios"
      [placeholder]="'room.filter' | translate"
      (ionInput)="onFilter(filter)"></ion-searchbar>
  </div>
  @if (loading()) {
    <app-loading></app-loading>
  }
  @if (floors().length > 0) {
    @for (floor of floors(); track $index) {
      <div class="floor-container">
        <ion-item button="true">
          @if (floor.show.floor) {
            <ion-icon slot="start"
              name="chevron-down-outline"
              (click)="floor.show.floor= !floor.show.floor"></ion-icon>
          } @else {
            <ion-icon slot="start"
              name="chevron-up-outline"
              (click)="floor.show.floor = !floor.show.floor"></ion-icon>
          }
          <span (click)="onBlueprint(floor)">
            {{ 'room.floor' | translate }} {{ floor.name }}
          </span>
        </ion-item>
        @if (floor.show.floor) {
          @if (filter.value.length === 0 || floor.commercial.length > 0) {
            <ion-item lines="none"
              class="child">
              @if (floor.show.commercial) {
                <ion-icon slot="start"
                  name="chevron-down-outline"
                  (click)="floor.show.commercial = !floor.show.commercial"></ion-icon>
              } @else {
                <ion-icon slot="start"
                  name="chevron-up-outline"
                  (click)="floor.show.commercial = !floor.show.commercial"></ion-icon>
              }
              {{ 'kanban.commercial' | translate }}
              @if (adminActionRoles.includes(roleS())) {
                <ion-button slot="end"
                  (click)="addRooms('commercial', floor.name)">
                  {{ 'room.addCommercialButton' | translate }}
                </ion-button>
              }
            </ion-item>
          }
          @if (floor.show.commercial) {
            @for (area of floor.commercial; track $index) {
              <ion-item lines="none"
                class="grandchild"
                button="true"
                (click)="area.areaSnapLink.action()">
                @if (area.selected) {
                  <ion-icon slot="start"
                    name="checkmark-outline"></ion-icon>
                } @else {
                  <ion-icon slot="start"
                    name="chevron-forward-outline"></ion-icon>
                }
                {{ area.name }}
                @if (area.users?.length > 0) {
                  - {{ area.users[area.users.length - 1].company }}
                }
                @if (area.areaSnapLink.notification$ | async; as notification) {
                  @if (notification > 0) {
                    <ion-badge class="count"
                      color="danger"
                      slot="end">{{ notification }}</ion-badge>
                  }
                }
              </ion-item>
            } @empty {
              @if (filter.value.length === 0) {
                <div class="grandchild empty">
                  {{ 'room.noRooms' | translate }}
                </div>
              }
            }
          }
          @if (filter.value.length === 0 || floor.common.length > 0) {
            <ion-item lines="none"
              class="child">
              @if (floor.show.common) {
                <ion-icon slot="start"
                  name="chevron-down-outline"
                  (click)="floor.show.common = !floor.show.common"></ion-icon>
              } @else {
                <ion-icon slot="start"
                  name="chevron-up-outline"
                  (click)="floor.show.common = !floor.show.common"></ion-icon>
              }
              {{ 'kanban.common' | translate }}
              @if (adminActionRoles.includes(roleS())) {
                <ion-button slot="end"
                  (click)="addRooms('common', floor.name)">
                  {{ 'room.addCommonButton' | translate }}
                </ion-button>
              }
            </ion-item>
          }
          @if (floor.show.common) {
            @for (area of floor.common; track area.guid) {
              <ion-item lines="none"
                class="grandchild"
                button="true"
                (click)="area.areaSnapLink.action()">
                @if (area.selected) {
                  <ion-icon slot="start"
                    name="checkmark-outline"></ion-icon>
                } @else {
                  <ion-icon slot="start"
                    name="chevron-forward-outline"></ion-icon>
                }
                {{ area.name }}
                @if (area.areaSnapLink.notification$ | async; as notification) {
                  @if (notification > 0) {
                    <ion-badge class="count"
                      color="danger"
                      slot="end">{{ notification }}</ion-badge>
                  }
                }
              </ion-item>
            } @empty {
              @if (filter.value.length === 0) {
                <div class="grandchild empty">
                  {{ 'room.noRooms' | translate }}
                </div>
              }
            }
          }
        }
      </div>
    }
  } @else {
    @if (isCommercial()) {
      <h4>{{ 'kanban.commercial' | translate }}</h4>
      @for (area of vm.commercialAreas; track area.guid) {
        <ion-item lines="none"
          button="true"
          (click)="area.areaSnapLink.action()">
          {{ area.name }}
          @if (area.users?.length > 0) {
            - {{ area.users[area.users.length - 1].company }}
          }
          @if (area.areaSnapLink.notification$ | async; as notification) {
            @if (notification > 0) {
              <ion-badge class="count"
                color="danger"
                slot="end">{{ notification }}</ion-badge>
            }
          }
        </ion-item>
      } @empty {
        {{ 'room.noRooms' | translate }}
      }
      @if (adminActionRoles.includes(roleS())) {
        <div class="ion-margin-top">
          <ion-button color="light"
            (click)="addRooms('commercial')">
            {{ 'room.addCommercialButton' | translate }}
          </ion-button>
        </div>
      }
      <h4>{{ 'kanban.common' | translate }}</h4>
      @for (area of vm.commonAreas; track area.guid) {
        <ion-item lines="none"
          button="true"
          (click)="area.areaSnapLink.action()">
          {{ area.name }}
          @if (area.areaSnapLink.notification$ | async; as notification) {
            @if (notification > 0) {
              <ion-badge class="count"
                color="danger"
                slot="end">{{ notification }}</ion-badge>
            }
          }
        </ion-item>
      } @empty {
        {{ 'room.noRooms' | translate }}
      }
      @if (adminActionRoles.includes(roleS())) {
        <div class="ion-margin-top">
          <ion-button color="light"
            (click)="addRooms('common')">
            {{ 'room.addCommonButton' | translate }}
          </ion-button>
        </div>
      }
      <h4>{{ 'kanban.room' | translate }}</h4>
      <div class="child-container">
        @for (area of vm.areas; track area.guid) {
          <app-snap-link [item]="area.areaSnapLink"></app-snap-link>
        } @empty {
          {{ 'room.noRooms' | translate }}
        }
      </div>
      @if (adminActionRoles.includes(roleS())) {
        <div class="ion-margin-top">
          <ion-button color="light"
            (click)="addRooms('residence')">
            {{ 'room.addRoomsButton' | translate }}
          </ion-button>
        </div>
      }
    } @else {
      <h4>{{ 'kanban.room' | translate }}</h4>
      <div class="child-container">
        @for (area of vm.areas; track area.guid) {
          <app-snap-link [item]="area.areaSnapLink"></app-snap-link>
        } @empty {
          {{ 'room.noRooms' | translate }}
        }
      </div>
      @if (adminActionRoles.includes(roleS())) {
        <div class="ion-margin-top">
          <ion-button color="light"
            (click)="addRooms('residence')">
            {{ 'room.addRoomsButton' | translate }}
          </ion-button>
        </div>
      }
      <h4>{{ 'kanban.commercial' | translate }}</h4>
      @for (area of vm.commercialAreas; track area.guid) {
        <ion-item lines="none"
          button="true"
          (click)="area.areaSnapLink.action()">
          {{ area.name }}
          @if (area.areaSnapLink.notification$ | async; as notification) {
            @if (notification > 0) {
              <ion-badge class="count"
                color="danger"
                slot="end">{{ notification }}</ion-badge>
            }
          }
        </ion-item>
      } @empty {
        {{ 'room.noRooms' | translate }}
      }
      @if (adminActionRoles.includes(roleS())) {
        <div class="ion-margin-top">
          <ion-button color="light"
            (click)="addRooms('commercial')">
            {{ 'room.addCommercialButton' | translate }}
          </ion-button>
        </div>
      }
      <h4>{{ 'kanban.common' | translate }}</h4>
      @for (area of vm.commonAreas; track area.guid) {
        <ion-item lines="none"
          button="true"
          (click)="area.areaSnapLink.action()">
          {{ area.name }}
          @if (area.areaSnapLink.notification$ | async; as notification) {
            @if (notification > 0) {
              <ion-badge class="count"
                color="danger"
                slot="end">{{ notification }}</ion-badge>
            }
          }
        </ion-item>
      } @empty {
        {{ 'room.noRooms' | translate }}
      }
      @if (adminActionRoles.includes(roleS())) {
        <div class="ion-margin-top">
          <ion-button color="light"
            (click)="addRooms('common')">
            {{ 'room.addCommonButton' | translate }}
          </ion-button>
        </div>
      }
    }
  }
}